import { ContextMenuItem } from '@cad-arc';
import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '@m43/core';
import { UnitResource } from '@mark43/cad-api';

export function RemoveHoldItem({
    unitId,
    agencyEventId,
}: {
    unitId: number;
    agencyEventId: number;
}): React.ReactElement {
    const apiClient = useApiClient();
    const mutation = useMutation(
        ({ unitId, agencyEventId }: { unitId: number; agencyEventId: number }) => {
            return apiClient.request<UnitResource.RemoveHeldUnits>({
                method: 'POST',
                url: 'unit/held_units/remove/',
                data: { unitIds: [unitId], agencyEventIds: [agencyEventId] },
            });
        }
    );
    return (
        <ContextMenuItem onSelect={() => mutation.mutate({ unitId, agencyEventId })}>
            Remove Hold
        </ContextMenuItem>
    );
}
